
<div class="tile_wrapper">
  <div class=" tile_css p-3 white_bg">
    <img *ngIf="icon" src="../../../../assets/img/icons/{{icon}}" alt="">
      <p class="title_css">{{title}}</p>
  </div>
</div>